/**
 * Custom code supported by @MaxDesignFR
 */
(() => {
  const templates = {
    index: document.body.classList.contains('template-index'),
    product: document.body.classList.contains('template-product'),
    collection: document.body.classList.contains('template-collection'),
  };

  if (templates.product) {
    customDatePicker();
    reputonAnchor();
    bookForm();
    updatePriceAsNew();
    updatePriceHT();
    updateSavingsBadge();

  }
  if (templates.collection) {
    quickATC();
  }

  /*************************************************************************************/

  /**
   * Custom search layout for a smaller header design
   * Keyboard supported
   */
  (function headerLayout() {
    const searchWrapper = document.querySelector('.site-header .live-search');
    if (!searchWrapper) return;

    const searchForm = searchWrapper.querySelector('form');
    const searchBtn = searchWrapper.querySelector('.live-search-button');
    const searchInput = searchWrapper.querySelector('.form-field-input');

    document.body.addEventListener('click', e => !searchWrapper.contains(e.target) && closeSearch());
    searchBtn.addEventListener('click', e => e.preventDefault());
    searchBtn.addEventListener('mousedown', onMousedown);
    searchBtn.addEventListener('keydown', onKeydown);
    searchBtn.addEventListener('focusin', openSearch);
    searchWrapper.addEventListener('focusout', onFocusout);

    function onMousedown(e) {
      e.preventDefault();
      if (searchWrapper.hasAttribute('data-search-open')) {
        if (searchInput.value.trim() != '') searchForm.submit();
        else closeSearch();
      } else openSearch();
    }

    function onKeydown(e) {
      if (e.keyCode === 13 && searchInput.value.trim() != '') searchForm.submit();
    }

    function onFocusout(e) {
      if (e.relatedTarget && !searchWrapper.contains(e.relatedTarget)) closeSearch();
    }

    function closeSearch() {
      searchWrapper.removeAttribute('data-search-open');
      searchInput.blur();
    }

    function openSearch(e) {
      searchWrapper.setAttribute('data-search-open', '');
      if (!e || !e.relatedTarget || e.relatedTarget != searchInput) searchInput.focus();
    }
  })();

  /*************************************************************************************/

  /**
   * Custom date picker config with flatPickr
   */

  function customDatePicker() {
    const datePicker = document.querySelector('[data-flatpickr]');
    if (!datePicker) return;
    document.addEventListener('modal:script:ready', e => {
      const modal = e.detail;
      if (modal.dataset.id == 'reserve-form') {
        flatpickr(datePicker, {
          altInput: true,
          altFormat: 'j F Y',
          minDate: 'today',
          disable: [date => modal.settings.datePicker.disabledDays.includes(date.getDay())],
          locale: {
            firstDayOfWeek: 1,
            ordinal: nth => {
              if (nth > 1) return '';
              return 'er';
            },
          },
        });
      }
    });
  }

  /*************************************************************************************/

  /**
   * Update or add input field based on regular formData object
   */
  function bookForm() {
    // toggle custom fields based on pickup choice
    const modal = document.querySelector('.mmd[data-id="reserve-form"]');
    const ecochequeField = modal.querySelector('fieldset[name="ecocheque_number"]');
    const pickUpChoices = [...modal.querySelectorAll('input[name="contact[choice]"]')];
    pickUpChoices.forEach(input =>
      input.addEventListener('change', e => {
        const isLastOption = pickUpChoices.indexOf(e.target) == pickUpChoices.length - 1;
        ecochequeField.disabled = !isLastOption;
        console.log('🚀 ~ isLastOption:', isLastOption);
      })
    );
    // update contact form on modal open
    document.addEventListener('modal:open', e => {
      const modal = e.detail;
      const reserveModal = modal.dataset.id == 'reserve-form';
      if (!reserveModal) return;
      const customFormData = new FormData(document.querySelector('[data-product-form-area] form[action*="cart/add"]'));
      // prop & variant entries
      for (let entry of customFormData.entries()) {
        if (entry[0] == 'form_type' || entry[0] == 'utf8' || entry[0] == 'id') continue;
        const inputName = entry[0].includes('properties')
          ? `contact${entry[0].replace('properties', '')}`
          : `contact[${entry[0]}]`;
        const inputValue = entry[1];
        const inputEntry = modal.querySelector(`[name="${inputName}"]`);
        if (inputEntry) inputEntry.value = inputValue;
        else {
          modal.insertAdjacentHTML(
            'afterbegin',
            `<input type="hidden" name="${inputName}" value="${inputValue}"></input>`
          );
        }
      }
      // price entry
      const priceNode = document.querySelector('.price__current .money');
      if (priceNode) {
        const priceEntry = modal.querySelector(`[name="contact[Prix]"]`);
        const priceValue = priceNode.textContent.trim();
        if (priceEntry) priceEntry.value = priceValue;
        else {
          modal.insertAdjacentHTML(
            'afterbegin',
            `<input type="hidden" name="contact[Prix]" value="${priceValue}"></input>`
          );
        }
      }
    });
  }

  /*************************************************************************************/

  /**
   * Make top widget redirect to main widget on click to avoid trafic depletion
   */
  function reputonAnchor() {
    const compactWidget = document.querySelector('[data-reputon-anchor]');
    const mainWidget = document.querySelector('.reputon-google-reviews-widget:not([data-reputon-anchor])');
    if (!compactWidget || !mainWidget) return;
    compactWidget.addEventListener('click', e => {
      e.preventDefault();
      mainWidget.scrollIntoView({ behavior: 'smooth' });
    });
  }

  /*************************************************************************************/

  /**
   * Quick ATC collection page
   */
  function quickATC() {
    const mobileATCs = document.querySelectorAll('.productitem__atc--mobile');
    for (let atc of mobileATCs) {
      atc.addEventListener('click', e => {
        const container = e.target.closest('.productitem__container');
        if (!container) return;
        const formBtn = container.querySelector('form button');
        formBtn && formBtn.click();
      });
    }
  }

  /*************************************************************************************/

  /**
   * Update metafield maxdesign.price_as_new on variant change
   */
  function updatePriceAsNew() {
    const priceAsNew = document.querySelector('.price-as-new');
    const variantModule = document.querySelector('.variant-selection');
    if (!priceAsNew || !variantModule) return;
    const pricesData = JSON.parse(priceAsNew.querySelector(':scope > [type="application/json"]').innerText);
    const priceNode = priceAsNew.querySelector('del [data-price]');
    variantModule.addEventListener('variant-change', e => {
      const variantId = e?.detail?.variant?.id;
      if (pricesData.hasOwnProperty(variantId)) priceNode.textContent = pricesData[variantId];
    });
  }

  /*************************************************************************************/

  /**
   * Update price HT (hors taxes)
   */
  function updatePriceHT() {
    const priceHT = document.querySelector('.price-ht');
    const variantModule = document.querySelector('.variant-selection');
    if (!priceHT || !variantModule) return;
    const pricesData = JSON.parse(priceHT.querySelector(':scope > [type="application/json"]').innerText);
    const priceNode = priceHT.querySelector('[data-price]');
    variantModule.addEventListener('variant-change', e => {
      const variantId = e?.detail?.variant?.id;
      if (pricesData.hasOwnProperty(variantId)) priceNode.textContent = pricesData[variantId];
    });
  }

    /**
   * Sync old price next to "Réduction" badge with selected variant
   * Updates: <span data-badge-compare-at> <span data-price-compare>...</span>
   */
  function syncBadgeCompareAt() {
    const row = document.querySelector(".product__badge-sale-row");
    const wrap = document.querySelector("[data-badge-compare-at]");
    const node = document.querySelector("[data-badge-compare-at] [data-price-compare]");
    const variantModule = document.querySelector(".variant-selection");

    if (!node || !wrap) return;

    // fallback money formatter (Shopify cents -> EUR style)
    function formatMoney(cents) {
      // If Shopify.formatMoney exists, use it.
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        // Use theme default money format if available
        const fmt = (window.theme && window.theme.moneyFormat) || "{{amount_with_comma_separator}} €";
        return window.Shopify.formatMoney(cents, fmt);
      }
      // Minimal fallback
      const eur = (cents / 100).toFixed(2).replace(".", ",");
      return `€ ${eur}`;
    }

    function applyVariant(variant) {
      if (!variant) return;

      const price = Number(variant.price || 0);
      const compare = Number(variant.compare_at_price || 0);

      const isOnSale = compare > price && compare > 0;

      // Show/hide compare-at next to the badge
      wrap.style.display = isOnSale ? "" : "none";
      if (row) row.style.display = ""; // keep row visible (badge itself managed by theme)

      if (isOnSale) {
        node.textContent = formatMoney(compare);
      }
    }

    // Listen to Empire variant change event
    if (variantModule) {
      variantModule.addEventListener("variant-change", (e) => {
        applyVariant(e && e.detail && e.detail.variant);
      });

      // init using current variant if theme exposes it
      if (variantModule.__currentVariant) {
        applyVariant(variantModule.__currentVariant);
        return;
      }
    }

    // init fallback: read variant id from add-to-cart form and find it in product JSON if present
    const idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    const currentId = idInput ? Number(idInput.value) : null;

    // Some themes expose product JSON on the page; if not, we just leave as-is.
    const productJsonEl = document.querySelector('[type="application/json"][data-product-json]');
    if (currentId && productJsonEl) {
      try {
        const product = JSON.parse(productJsonEl.textContent);
        const v = (product.variants || []).find(x => Number(x.id) === currentId);
        applyVariant(v);
      } catch (err) {}
    }
  }

  // Call it on product pages
  syncBadgeCompareAt();

})();

  /*************************************************************************************/

  /**
   * Update saving badge
   */
  
  function updateSavingsBadge() {
  const pricing = document.querySelector(".product-pricing");
  const badge = document.querySelector(".price-save-badge[data-savings-badge]");
  if (!pricing || !badge) return;

  const jsonNode = badge.querySelector('script[data-savings-json]');
  const valueNode = badge.querySelector('[data-savings]');
  const variantModule = document.querySelector(".variant-selection");
  if (!jsonNode || !valueNode || !variantModule) return;

  const data = JSON.parse(jsonNode.textContent);

  function apply(variantId) {
    const entry = data[String(variantId)];
    if (!entry) return;

    if (entry.cents > 0) {
      valueNode.textContent = entry.formatted;
      badge.style.display = "";
    } else {
      badge.style.display = "none";
    }
  }

  variantModule.addEventListener("variant-change", (e) => {
    const id = e?.detail?.variant?.id;
    if (id) apply(id);
  });

  // init (si le thème expose la variante courante)
  const current = variantModule?.__currentVariant?.id;
  if (current) apply(current);
}
